import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserLiftPermission } from '../../models/user-lift-permission.model';
import { IUser } from '../../models/user.model';
import { ModalComponent } from 'src/app/core/components/modal/modal.component';
import { UserLiftPermissionService } from '../../services/usr-lift-permission.service';
import { UINotificationService } from 'src/app/core/services/ui-notification.service';
import { NotificationType } from 'src/app/core/models/ui-notification.model';
import { UserDetail } from '../../models/user-detail';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-lift-permission',
  templateUrl: './user-lift-permission.component.html',
  styleUrls: ['./user-lift-permission.component.css']
})
export class UserLiftPermissionComponent implements OnInit {
  permissions: UserLiftPermission[];
  user: UserDetail;
  menu = 'permission';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userLiftPermissionService: UserLiftPermissionService,
    private uiNotificationService: UINotificationService,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    this.permissions = this.route.snapshot.data.permissions;
    this.user = this.route.snapshot.data.user;
  }

  goToDetail() {
    this.router.navigate([{ outlets: { modal: ['user-detail', this.user.id] } }]);
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  submitPermissions(modal: ModalComponent) {
    if (this.permissions.length > 0) {
      const data = {
        companyId: this.permissions[0].companyId,
        lifts: this.permissions.map((data) => {
          return {
            liftId: data.lift.liftId,
            permissionCodes: data.lift.permissionCodes
          }
        })
      }

      this.userLiftPermissionService.setUserPermission(this.user.login.id, data).subscribe(() => this.onSuccessUpdate(modal));
    }
  }

  onChange(item, value) {
    if (item.lift.permissionCodes.includes(value)) {
      const index = item.lift.permissionCodes.indexOf(value);
      item.lift.permissionCodes.splice(index, 1);
    } else {
      item.lift.permissionCodes.push(value);
    }
  }

  onMenuChange(itemName: string) {
    if (itemName == 'basic') {
      this.goToDetail();
    }

    if (itemName == 'permission') {
      return;
    }
  }

  private onSuccessUpdate(modal: ModalComponent) {
    this.uiNotificationService.add({
      type: NotificationType.Info,
      message: 'Práva byla aktualizována'
    });
    modal.closeModal(null);
  }

}
